import { render } from "./RemoveUser.vue?vue&type=template&id=5eadb184"
import script from "./RemoveUser.vue?vue&type=script&lang=ts"
export * from "./RemoveUser.vue?vue&type=script&lang=ts"
script.render = render

export default script